import { Text } from '@elkaso-app/web-design';
import { Link } from 'react-router-dom';

export interface IRestaurantTransferCodeCell {
  code: string;
}

export const RestaurantTransferCodeCell = ({ code }: IRestaurantTransferCodeCell) => {
  return (
    <Link to={`/app/restaurant-transfers/details/${code}`}>
      <Text color={'red.500'} fontWeight='500' _hover={{ color: 'red.500' }} _focus={{ color: 'red.500' }}>
        #{code}
      </Text>
    </Link>
  );
};
